import React, { useEffect } from "react";
import { X } from "lucide-react";
import { LEGAL_DOCUMENTS } from "./LegalDocumentContent";

export default function LegalDocumentModal({ documentKey, onClose }) {
  const config = documentKey ? LEGAL_DOCUMENTS[documentKey] : null;
  const Content = config?.content || null;

  useEffect(() => {
    if (!config) return undefined;

    function onKeyDown(event) {
      if (event.key === "Escape") onClose();
    }

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [config, onClose]);

  if (!config || !Content) return null;

  return (
    <div
      className="fixed inset-0 z-[140] flex items-center justify-center bg-slate-950/70 px-4 py-6 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      aria-label={config.title}
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div className="flex h-[90vh] w-full max-w-5xl flex-col overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-2xl">
        <div className="flex items-center justify-between gap-4 border-b border-slate-200 px-6 py-4">
          <div>
            <div className="text-xs font-black uppercase tracking-[0.18em] text-blue-700">
              AI Fine Protector legal document
            </div>
            <div className="mt-1 text-lg font-black text-slate-950">{config.title}</div>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label={`Close ${config.title}`}
            className="rounded-xl border border-slate-200 p-2 text-slate-500 hover:bg-slate-50 hover:text-slate-950"
          >
            <X size={20} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto bg-slate-50 px-5 py-6 sm:px-8">
          <div className="mx-auto max-w-4xl rounded-3xl border border-slate-100 bg-white p-6 shadow-sm sm:p-10">
            <Content compact />
          </div>
        </div>

        <div className="flex justify-end border-t border-slate-200 bg-white px-6 py-4">
          <button
            type="button"
            onClick={onClose}
            className="rounded-xl bg-slate-950 px-5 py-3 text-sm font-extrabold text-white hover:bg-slate-800"
          >
            Return to Checkout Confirmation
          </button>
        </div>
      </div>
    </div>
  );
}
